import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';

import { Banner } from '@/components/ui/banner/index';
import { useHashRoute } from '@/hooks/useHashRoute';
import { trackEvent } from '@/utils/analytics';

import { ReferralCta } from './referral-cta';
import { useSubscription } from './subscription.query';

export const MeetingLimitBanner = observer(() => {
  const subscription = useSubscription();
  const { setHash } = useHashRoute();

  const handleUpgrade = () => {
    trackEvent('UPGRADE_BUTTON_CLICKED', { source: 'meeting_limit_banner' });
    setHash('settings/Subscription');
  };

  useEffect(() => {
    if (subscription.hasReachedMeetingLimit) {
      trackEvent('MEETING_LIMIT_HIT');
    }
  }, [subscription.hasReachedMeetingLimit]);

  if (!subscription.hasReachedMeetingLimit) return null;

  return (
    <Banner.Root>
      <Banner.Content>
        <Banner.Title>You've reached your limit</Banner.Title>
        <Banner.Description>
          Upgrade to unlock unlimited recording and continue taking notes
        </Banner.Description>
      </Banner.Content>
      <Banner.Actions>
        <Banner.Action variant="default" onClick={handleUpgrade}>
          Upgrade
        </Banner.Action>
        <ReferralCta source="meeting_limit_banner" />
      </Banner.Actions>
    </Banner.Root>
  );
});
